<template>
  <div class="main">
    <div style="padding: 10px 20px 0;">
      <el-button type="success" plain v-print="option">打印</el-button>
      <el-switch
        v-model="showEmptyRows"
        active-text="显示空行"
        inactive-text="隐藏空行"
        style="margin-left: 15px"
      >
      </el-switch>
    </div>
    <div id="printbox"></div>
  </div>
</template>
<script>
import JsBarcode from "jsbarcode";
import qrCode from "arale-qrcode";
import optionMixins from "@/mixins/option";
export default {
  mixins: [optionMixins],
  data() {
    return {
      api: require("@/api/sy/printTemplate").default,
      data: {
        TemplateId: 0,
        TemplateName: "",
        DataApi: "",
        DocType: "",
        HtmlString: "",
        HtmlPrintString: "",
        DomJsonData: "",
        PaperJsonData: "",
        IsDefault: false,
      },
      maxPage: 0,
      value: null,
      option: {
        id: "printbox", // 这里是要打印元素的ID
        popTitle: "", // 打印的标题
        extraCss: "", // 打印可引入外部的一个 css 文件
        extraHead: "", // 打印头部文字
      },
      paperSize: [
        { label: "A4", value: { width: '210mm', height: '297mm' } },
        { label: "自定义", value: { width: '', height: '' } }
      ],
      loading: null,
      showEmptyRows: true, // 控制是否显示空行
    }
  },
  mounted() {
    console.log('customview');
    this.loading = this.$loading({
      lock: true,
      text: "正在加载...",
      spinner: "el-icon-loading",
      customClass: "my_loading",
      background: "rgba(0, 0, 0, 0.3)",
    });

    var params = this.$route.params;
    // console.log('params', this.$route.params);
    if (params.type) this.data.DocType = params.type;
    if (params.value) this.value = params.value;

    this.api.info({ DocType: this.data.DocType }).then(res => {
      if (res.Code == 0) {
        var data = res.Data;
        this.data.TemplateId = data.TemplateId;
        this.data.TemplateName = data.TemplateName;
        this.data.DataApi = data.DataApi;
        this.data.DocType = data.DocType;
        this.data.HtmlString = data.HtmlString;
        this.data.HtmlPrintString = data.HtmlPrintString;
        this.data.DomJsonData = data.DomJsonData;
        this.data.PaperJsonData = data.PaperJsonData;
        this.callOptionApi().then(() => {
          this.onSet();
        })
      }
    })
  },
  methods: {
    onSet() {
      // console.log("onSet", this.data)
      var printbox = document.getElementById("printbox");

      var printConfig = JSON.parse(this.data.PaperJsonData);
      var tempBox = document.createElement("div");
      tempBox.id = "$#*#$"
      tempBox.className = "box";
      ["Top", "Right", "Bottom", "Left"].forEach(x => {
        if (printConfig["padding" + x]) tempBox.style["padding" + x] = printConfig["padding" + x] + "px";
      })

      var paper = this.paperSize.find(x => x.label == printConfig.paper);
      if (paper.label != "自定义") {
        var width = "calc(" + paper.value.width + " - 2px)";
        var height = "calc(" + paper.value.height + " - 2px)";
        if (printConfig.direction == 1) {
          var container = width;
          width = height;
          height = container;
        }
        tempBox.style.width = width;
        tempBox.style.height = height;
      } else {
        var width = "calc(" + printConfig.customWidth + "mm - 2px)";
        var height = "calc(" + printConfig.customHeight + "mm - 2px)";
        tempBox.style.width = width;
        tempBox.style.height = height;
      }

      var ele_paper = document.createElement("div");
      ele_paper.className = "paper";

      // var ele_paper = document.getElementsByClassName(".paper");
      ele_paper.innerHTML = this.data.HtmlString;
      // console.log("ele_paper", [ele_paper]);

      var field_items = ele_paper.querySelectorAll(".field-item");
      Array(...field_items).forEach(x => {
        x.style.borderColor = "white";
        x.firstElementChild.style.borderColor = "white";
      })
      var items = ele_paper.querySelectorAll(".text-item,.img-item,.page-item");
      Array(...items).forEach(x => {
        x.style.borderColor = "white";
      })

      var dragDoms = JSON.parse(this.data.DomJsonData);
      // console.log('dragDoms', dragDoms);
      var fields = dragDoms.filter(x => x.domId.indexOf("field_") != -1);
      // this.data.Fields = fields.map(x => x.tableName);
      var tables = dragDoms.filter(x => x.domId.indexOf("table_") != -1);
      // var imgs = dragDoms.filter(x => x.domId.indexOf("img_") != -1);
      // var texts = dragDoms.filter(x => x.domId.indexOf("text_") != -1);
      // var pages = dragDoms.filter(x => x.domId.indexOf("page_") != -1);
      // console.log('data', JSON.parse(JSON.stringify({ Fields: fields, Tables: tables, Pages: pages, Imgs: imgs, Texts: texts })));
      // console.log('tables', JSON.parse(JSON.stringify(tables)))
      
      var dataApi = require("@/api" + this.data.DataApi).default;
      

      dataApi.info(this.value).then(res => {
        if (res.Code == 0) {
          var data = res.Data;
          // console.log("data", data);
          fields.forEach(x => {
            // console.log(x);
            var value = data[x.tableName];
            var item = ele_paper.querySelector('[data-identify="' + x.domId + '"]');
            item.lastElementChild.style.color = "";
            if (x.dataType == "string") {
              item.lastElementChild.innerText = value;
            }
            if (x.dataType == "datetime") {
              try {
                if (!value) item.lastElementChild.innerText = "";
                else item.lastElementChild.innerText = this.$dayjs(value).format(x.format);
              } catch (error) {
                item.lastElementChild.innerText = value;
              }
            }
            if (x.dataType == "barcode") {
              var img = document.createElement('img');
              // console.log("item", [item])
              JsBarcode(img, value, {
                format: "CODE128",
                width: 1,//设置条之间的宽度
                displayValue: true,
                fontSize: 14,
                height: 30
              }); //原生JS方式
              item.lastElementChild.innerHTML = "";
              item.lastElementChild.appendChild(img);
            }
            if (x.dataType == "qrcode") {
              var codeFigure = new qrCode({ "render": "svg", "text": value, "size": 80 });
              item.lastElementChild.innerHTML = "";
              item.lastElementChild.appendChild(codeFigure);
            }
            if (x.dataType == "numerical") {
              if (!value) item.lastElementChild.innerText = "";
              else item.lastElementChild.innerText = this["get" + x.format](value); //调用 mixins 中 option.js 里的函数，对数值进行格式化。
            }
          })

          tempBox.appendChild(ele_paper);

          tables.forEach(x => {
            var pageSize = 0;
            data[x.tableName] = data[x.tableName].map((w, i) => { return { ...w, Index: i + 1 } });
            if (data[x.tableName].length <= Number(x.rows)) pageSize = 1;
            else pageSize = Math.ceil(data[x.tableName].length / Number(x.rows));
            if (pageSize > this.maxPage) this.maxPage = pageSize;
          })

          var page_totals = tempBox.querySelectorAll('[data-page="PageTotal"]');

          Array(...page_totals).forEach(x => x.innerText = "共" + this.maxPage + "页");
          console.log('max', this.maxPage);
          for (let i = 0; i < this.maxPage; i++) {
            var page_indexs = tempBox.querySelectorAll('[data-page="PageIndex"]');
            Array(...page_indexs).forEach(x => x.innerText = "第" + (i + 1) + "页");

            var box = document.createElement("div");
            printbox.appendChild(box);
            box.outerHTML = tempBox.outerHTML.replace("$#*#$", "box_" + i);
          }

          // console.log("printbox", printbox.children)
          Array(...printbox.children).forEach((e, i) => {
            // console.log("index_" + i, [e.firstElementChild]);
            tables.forEach(x => {
              var table = e.querySelector('[data-identify="' + x.domId + '"]');
              table.style.height = "";
              var ths = table.querySelectorAll("th");
              Array(...ths).forEach(x => x.style.cursor = "");
              var tbody = table.querySelector("tbody");
              var first_tr = tbody.firstElementChild;
              first_tr.style.display = "none";

              var rank = table.querySelector(".el-icon-rank");
              rank.remove();
              var rownumber = table.querySelector(".row-number");
              var rows = Number(rownumber.dataset.rows);
              rownumber.remove();

              // console.log("rows", rows, i * rows, (i * rows) + rows);
              // console.log('length', data[x.tableName]);
              var details = data[x.tableName].slice(i * rows, (i * rows) + rows);
              
              // 计算需要添加的空行数
              const emptyRowsCount = rows - details.length;
              
              // 先添加有数据的行
              details.forEach(w => {
                var tr = document.createElement('tr');
                tr.style.height = "24px";
                var tbfield = Array(...first_tr.children);
                Array(...tbfield).forEach(i => {
                  var td = document.createElement('td');
                  td.style.cssText = i.style.cssText;
                  var value = "";
                  if (i.dataset.tbfield) {
                    value = w[i.dataset.tbfield];
                    if (i.dataset.tbfield == "Sn") value = w.Index;
                  }
                  var col = x.columns[i.cellIndex];
                  // console.log(i.cellIndex, col.dataType, col.format, i.dataset.tbfield, value);
                  if (col.dataType == "string") {
                    td.innerText = value;
                  }
                  if (col.dataType == "datetime") {
                    try {
                      if (!value) td.innerText = "";
                      else td.innerText = this.$dayjs(value).format(col.format);
                    } catch (error) {
                      td.innerText = value;
                    }
                  }
                  if (col.dataType == "barcode") {
                    var img = document.createElement('img');
                    JsBarcode(img, value, {
                      format: "CODE128",
                      width: 1,//设置条之间的宽度
                      displayValue: true,
                      fontSize: 14,
                      height: 30
                    }); //原生JS方式
                    td.innerHTML = "";
                    td.appendChild(img);
                  }
                  if (col.dataType == "qrcode") {
                    var codeFigure = new qrCode({ "render": "svg", "text": value, "size": 80 });
                    td.innerHTML = "";
                    td.appendChild(codeFigure);
                  }
                  if (col.dataType == "numerical") {
                    if (!value) td.innerText = "";
                    else td.innerText = this["get" + col.format](value); //调用 mixins 中 option.js 里的函数，对数值进行格式化。
                  }
                  tr.appendChild(td);
                })
                tbody.appendChild(tr);
              })

              // 添加空行
              if (this.showEmptyRows) {  // 根据控制变量决定是否添加空行
                for (let j = 0; j < emptyRowsCount; j++) {
                  var tr = document.createElement('tr');
                  tr.style.height = "24px";
                  var tbfield = Array(...first_tr.children);
                  Array(...tbfield).forEach((cell, cellIndex) => {
                    var td = document.createElement('td');
                    td.style.cssText = first_tr.firstElementChild.style.cssText;
                    
                    // 如果是序号列，则显示序号
                    if (cell.dataset.tbfield === "Sn") {
                      // 计算当前空行的序号：当前页起始序号 + 当前页数据长度 + 当前空行的索引
                      const currentIndex = (i * rows) + details.length + j + 1;
                      td.innerText = currentIndex;
                    } else {
                      td.innerHTML = "&nbsp;"; // 其他列显示空格
                    }
                    
                    tr.appendChild(td);
                  })
                  tbody.appendChild(tr);
                }
              }

              var tfoot = table.querySelector("tfoot");
              if (tfoot) {
                var total_tr = tfoot.querySelector('[data-total="total"]');
                // console.log('total_tr', [total_tr]);
                if (total_tr != null) {
                  Array(...total_tr.children).forEach(td => {
                    var field = td.dataset.field;
                    if (field) {
                      td.innerText = "";
                      var value = details.map(w => w[field]).reduce((a, b) => { return a + b });
                      var col = x.columns[td.cellIndex];
                      if (col.total && col.total.dataType == "numerical") {
                        value = this["get" + col.total.format](value); //调用 mixins 中 option.js 里的函数，对数值进行格式化。
                        td.innerText = value;
                      }
                    }
                  })
                }

                var intotal_tr = tfoot.querySelector('[data-total="intotal"]');
                if (intotal_tr != null) {
                  if ((printbox.children.length - 1) != i) {
                    intotal_tr.remove();
                  } else {
                    // console.log("最后一页");
                    Array(...intotal_tr.children).forEach(td => {
                      var field = td.dataset.field;
                      if (field) {
                        td.innerText = "";
                        var value = data[x.tableName].map(w => w[field]).reduce((a, b) => { return a + b });
                        var col = x.columns[td.cellIndex];
                        if (col.intotal && col.intotal.dataType == "numerical") {
                          value = this["get" + col.intotal.format](value); //调用 mixins 中 option.js 里的函数，对数值进行格式化。
                          td.innerText = value;
                        }
                      }
                    })
                  }
                }
              }

              // console.log("y值", x.y);
              // console.log("table", table.clientHeight, x.height);

              //找出y值比表格小的元素
              var mItems = dragDoms.filter(x => x.domId.indexOf("table_") == -1);
              mItems = mItems.filter(w => w.y > x.y);
              Array(...mItems).forEach(w => {
                var item = e.querySelector('[data-identify="' + w.domId + '"]');
                var height = item.offsetTop + (table.clientHeight - x.height);
                // console.log("height", height);
                item.style.top = height + "px";
              })
            })
          })

          this.loading.close();
        } else {
          this.loading.close();
        }
      })
    }
  },
  watch: {
    showEmptyRows: {
      handler(newVal) {
        // 清空打印区域
        document.getElementById("printbox").innerHTML = "";
        // 重新渲染表格
        this.onSet();
      }
    }
  }
}
</script>
<style lang="scss">
@media print {
  #printbox {
    margin: 0 !important;
    .box {
      border: none !important;
      margin: 0 !important;
      th .item_label {
        font-size: inherit !important;
      }
    }
  }
}
.main {
  position: relative;
  padding: 0;
  overflow: auto;
}
#printbox {
  margin: 20px;
  .box {
    border: 1px solid #dedede;
    .paper {
      page-break-after: always;
      width: 100%;
      height: 100%;
      position: relative;
      font-size: 12px;

      .table-item {
        position: absolute;
        cursor: default;

        table {
          width: 100%;
          height: 100%;
          .active-td {
            background-color: #cfe7ff;
          }
        }

        table,
        td,
        th {
          text-align: center;
          border: 1px solid #000;
          border-collapse: collapse;
        }

        table th {
          font-weight: unset;
        }

        // table td {
        //   padding: 10px 30px;
        // }
      }
    }
  }
  .box + .box {
    margin-top: 10px;
  }
}
</style>